import apiClient from "../api_services/ApiClient";
import { header } from "../../services/getcookie";

export const apiRequest = async ({
  method,
  url,
  data = {},
  params = {},
  headers,
}) => {
  try {
    const response = await apiClient({
      method,
      url,
      data,
      params,
      headers: headers || header(),
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
